<template>
  <div class="sidebar">
      <el-aside width="200px">
          <el-menu
            :default-active="onRoutes"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            background-color="#324157"
            text-color="#bfcbd9"
            active-text-color="#20a0ff"
            router
            :unique-opened='true'
          >
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>首页管理</span>
              </template>
              <el-menu-item-group>
                <!-- <el-menu-item index="scrollImage">轮播图</el-menu-item> -->
                <el-menu-item index="system">体系类别</el-menu-item>
                <el-menu-item index="itemSystem">产品体系</el-menu-item>
                <el-menu-item index="news">新闻中心</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>行业管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="BusinessList">行业</el-menu-item>
                 <el-menu-item index="Industry">行业应用</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>公司管理</span>
              </template>
              <el-menu-item-group>
               <el-menu-item index="companyInfo">公司信息</el-menu-item>
                <el-menu-item index="aboutUs">关于我们</el-menu-item>
                 <el-menu-item index="talents">人才招聘</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-aside>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    onRoutes() {
      // 浏览器刷新后，当前选中菜单任然高亮
      return this.$route.path.replace("/", "");
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleOpen(key, keyPath) {
     // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
     // console.log(key, keyPath);
    },
  },
};
</script>

<style lang="less" scoped>
.el-menu{
    border-right: 0;
}
.sidebar {
  background-color: rgb(50, 65, 87);
}
</style>